import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Typography from "../../Utility/Typography";
import ComingSoon from "../../Utility/ComingSoon/ComingSoon";
import { RiFileSettingsLine, RiMapPinLine, RiBuildingLine, RiUserLine } from "react-icons/ri";
import BillingConfigurationNavigation from "./BillingNavigation";
import TabMapping from "./TabMapping";
import ClientQBMapping from "./ClientQBMapping";
import UserRateMapping from "./UserRateMapping";

const BillingConfiguration = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getActiveTabFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("tab") || "tag-mapping";
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromUrl());

  useEffect(() => {
    setActiveTab(getActiveTabFromUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", tab);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: false,
    });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "tab-mapping":
        return <TabMapping title="Tag Mapping" icon={RiMapPinLine} />;
      case "client-qb-mapping":
        return <ClientQBMapping title="Client QB Mapping" icon={RiBuildingLine} />;
      case "user-rate-mapping":
        return <UserRateMapping title="User Rate Mapping" icon={RiUserLine} />;
      default:
        return <TabMapping title="Tag Mapping" icon={RiMapPinLine} />;
    }
  };

  return (
    <div className="w-full">
      {/* Configuration Navigation Tabs */}
      <BillingConfigurationNavigation activeTab={activeTab} onTabChange={handleTabChange} />

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

export default BillingConfiguration;
